import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "item-listing scrollable-table" }
const _hoisted_2 = { class: "itemsDiv" }
const _hoisted_3 = { class: "email-listings-table-header bold-text" }
const _hoisted_4 = { class: "email-listings-table-column display-inline-flex width35 margin-left-30" }
const _hoisted_5 = { class: "email-listings-table-column display-inline-flex width35" }
const _hoisted_6 = { class: "email-listings-table-column" }
const _hoisted_7 = { class: "email-listings-row inline-flex100" }
const _hoisted_8 = { class: "email-listings-address width35 margin-left-15 display-flex align-items-center" }
const _hoisted_9 = { class: "email-listings-sender width35 display-flex align-items-center" }
const _hoisted_10 = { class: "margin-left-14 width25 display-flex align-items-center" }
const _hoisted_11 = {
  class: "three-dots-btn",
  "data-toggle": "dropdown"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "dropdown-menu text-left" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("OrgSettings.EmailBranding.EmailAddress")), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("OrgSettings.EmailBranding.SenderName")), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("OrgSettings.EmailBranding.Status")), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailDomainListings, (domain) => {
        return (_openBlock(), _createElementBlock("div", {
          key: domain.DomainId
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(domain.Emails, (email) => {
            return (_openBlock(), _createElementBlock("div", {
              key: email.EmailId,
              class: "item-saparator div-program"
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, _toDisplayString(email.EmailAddress), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["margin-left-10", {'active-email-pill' : email.IsApplied}])
                  }, _toDisplayString(_ctx.SetAppliedEmail(email.IsApplied )), 3)
                ]),
                _createElementVNode("div", _hoisted_9, _toDisplayString(email.SenderName), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: _normalizeClass(email.IsActive ? 'success-status-pill' : 'fail-status-pill')
                  }, _toDisplayString(_ctx.SetEmailStatus(email.IsActive )), 3)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", _hoisted_11, [
                    _createElementVNode("img", { src: _ctx.threeDotsIcon }, null, 8, _hoisted_12)
                  ]),
                  _createElementVNode("ul", _hoisted_13, [
                    ((domain.DomainId !== 0) || (domain.DomainId === 0 && !domain.Emails.some(e => e.IsApplied)))
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          class: "manage-list-text hyperLink",
                          onClick: ($event: any) => (_ctx.SetEmailAsActive(email))
                        }, [
                          _createElementVNode("a", null, _toDisplayString(_ctx.$t("OrgSettings.EmailBranding.Activate")), 1)
                        ], 8, _hoisted_14))
                      : _createCommentVNode("", true),
                    _createElementVNode("li", {
                      class: "manage-list-text hyperLink",
                      onClick: ($event: any) => (_ctx.EditEmailAddress(email, domain.DomainId))
                    }, [
                      _createElementVNode("a", null, _toDisplayString(_ctx.$t("Dialogue.EditSurveyItem")), 1)
                    ], 8, _hoisted_15),
                    (domain.DomainId !== 0)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 1,
                          class: "manage-list-text hyperLink",
                          onClick: ($event: any) => (_ctx.EmitEmailAddressForDeletion(email, domain.DomainId))
                        }, [
                          _createElementVNode("a", null, _toDisplayString(_ctx.$t("Delete")), 1)
                        ], 8, _hoisted_16))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}